import {
    RaikoCustomSelect, raikoCustomSelectItemGenerator,
    RaikoGridOneColumn,
    RaikoGridTwoColumn, RaikoMaterialOutlinedInput,
    RaikoSectionContainer, RaikoToggleOutlined,
    showErrorMessage, showSuccessMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {useParams} from "react-router-dom";
import {FundService} from "../../../serverService/fund/FundService";
import {useEffect, useState} from "react";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";
import {GatewayTypes} from "../../../util/GatewayTypes";
import {stringIsEmpty} from "../../../util/VariableChecker";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {css} from "@emotion/css";

export default function FundDetailGatewayDetail({id}) {

    const service = new FundService()

    const [loading, setLoading] = useState(false)
    const loadingSniper = new LoadingHelper(useLoadingDispatcher())

    const [gatewayInfo, setGatewayInfo] = useState({
        title: "",
        type: ""
    })
    const [enabled, setEnabled] = useState(false);
    const [gatewayToken, setGatewayToken] = useState("");

    useEffect(() => {
        getGatewayDetail()
    }, []);

    function getGatewayDetail() {
        setLoading(true)
        service.getFundGatewayDetail(id)
            .then(({information, enabled, token}) => {
                setGatewayInfo(information)
                setEnabled(enabled.enabled)
                setGatewayToken(token.token)
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setLoading(false)
        })
    }


    function handleUpdateBasicInfo() {
        if (!stringIsEmpty(gatewayInfo.title)) {
            loadingSniper.show()
            service.updateFundGateway(id, gatewayInfo.title, gatewayInfo.type)
                .then(response => {
                    showSuccessMessage("بروزرسانی جزئيات با موفقیت انجام شد.")
                }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loadingSniper.hide()
            })
        } else
            showWarningMessage("لطفا نام درگاه را به درستی وارد نمایید.")
    }

    function handleUpdateTokenInfo() {
        if (gatewayInfo && gatewayToken.length > 0) {
            loadingSniper.show()
            service.updateFundGatewayToken(id, gatewayToken)
                .then(response => {
                    showSuccessMessage("بروزرسانی توکن با موفقیت انجام شد.")
                }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loadingSniper.hide()
            })
        } else {
            showWarningMessage("لطفا توکن دسترسی درگاه را به درستی وارد نمایید.")
        }
    }

    function handleUpdateEnabled() {
        loadingSniper.show()
        service.updateFundGatewayEnabled(id, enabled)
            .then(response => {
                showSuccessMessage("بروزرسانی وضعیت فعالسازی با موفقیت انجام شد.")
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loadingSniper.hide()
        })
    }

    return (
        <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
            <RaikoSectionContainer
                title={"اطلاعات پایه"}
                hasActionButton
                actionButtonOnclick={handleUpdateBasicInfo}
            >
                <RaikoGridTwoColumn>
                    <RaikoMaterialOutlinedInput
                        labelText={"نام صندوق"}
                        value={gatewayInfo.title}
                        setValue={value => {
                            setGatewayInfo(prev => {
                                return {
                                    ...prev,
                                    title: value
                                }
                            })
                        }}
                    />

                    <RaikoCustomSelect
                        labelText={"نوع درگاه"}
                        value={gatewayInfo.type}
                        setValue={value => {
                            setGatewayInfo(prev => {
                                return {
                                    ...prev,
                                    type: value
                                }
                            })
                        }}
                        items={[
                            raikoCustomSelectItemGenerator(GatewayTypes.ZARINPAL.id, GatewayTypes.ZARINPAL.name),
                            raikoCustomSelectItemGenerator(GatewayTypes.NEXTPAY.id, GatewayTypes.NEXTPAY.name),
                            raikoCustomSelectItemGenerator(GatewayTypes.PERSIAN_BANK.id, GatewayTypes.PERSIAN_BANK.name),
                        ]}
                    />
                </RaikoGridTwoColumn>
            </RaikoSectionContainer>

            <RaikoSectionContainer
                title={"توکن دسترسی"}
                subTitle={"توکن دریافت شده از درگاه پرداخت"}
                hasActionButton
                actionButtonOnclick={handleUpdateTokenInfo}
                actionButtonTitle={"بروزرسانی توکن"}
            >
                <RaikoMaterialOutlinedInput
                    labelText={"توکن"}
                    value={gatewayToken}
                    setValue={setGatewayToken}
                />
            </RaikoSectionContainer>

            <RaikoSectionContainer
                title={"فعالسازی"}
                hasActionButton
                actionButtonOnclick={handleUpdateEnabled}
                actionButtonTitle={"بروزرسانی"}
            >
                <RaikoToggleOutlined
                    checked={enabled}
                    setChecked={setEnabled}
                    labelText={"فعالسازی درگاه پرداخت"}
                />
            </RaikoSectionContainer>
        </RaikoGridOneColumn>
    )
}
